import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Transaction } from 'src/model/transaction.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { User } from 'src/model/user.model';
import { UserService } from 'src/services/user.service';
import { DeleteReasonRemarkComponent } from '../delete-reason-remark/delete-reason-remark.component';
import { EditTransactionComponent } from '../edit-transaction/edit-transaction.component';

@Component({
    selector: 'app-transaction-history',
    templateUrl: './transaction-history.component.html',
    styleUrls: ['./transaction-history.component.scss'],
    standalone: false
})
export class TransactionHistoryComponent implements OnInit {
  private router = inject(Router);
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  private sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  private userService = inject(UserService);

  @Input() public accountId;
  transactionList: Transaction[] = [];
  transactionSubtypeList: TransactionSubType[] = [];
  startDate: Date = new Date();
  endDate: Date = new Date();
  userList: User[] = [];
  selectedUsername: string;
  loggedInRole: number;
  carryForwardAmount: number;
  @Input() selectedCompany: number;

  isDirty = false;

  ngOnInit(): void {
    this.loggedInRole = Number(sessionStorage.getItem('roleId'));

    if (this.sharedService.isAdmin() == false && this.sharedService.isBossAccount() == false && !this.sharedService.isFinance())
      this.selectedCompany = Number(sessionStorage.getItem("companyId"));

    this.getAllTransactionSubtype();

    //always show today's transaction
    this.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    // this.getAccountCarryForwardAmount();

    // if (this.transactionList.length == 0) {
    this.getAllTransactions();
    this.getAllUsersInCompany();
    // }
  }

  setSelectedUser(username: string) {
    if (username === this.selectedUsername)
      return true
    else
      return false;
  }

  private getAllTransactionSubtype() {
    const xhttp = this.restApi.getRequest(this.constructApi.getAllTransactionSubTypes());

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const type = new TransactionSubType(json.id, json.name, json.type, json.assignable, json.enabled)
          this.transactionSubtypeList.push(type);
        });
      }
    };
  }

  getSubTypeName(subTypeId: number) {
    const index = this.transactionSubtypeList.findIndex(type => type.ID === subTypeId);

    return this.transactionSubtypeList[index].Name;
  }

  openEditTransactionDialog(transactionId: number, amount: number, remark: string) {
    const modalRef = this.sharedService.openModal(EditTransactionComponent);
    modalRef.componentInstance.transactionId = transactionId;
    modalRef.componentInstance.amount = amount;
    modalRef.componentInstance.remark = remark;
    //get account that was created
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      window.location.reload();
    });
  }

  openDeleteTransactionDialog(transaction: Transaction) {
    const timeDiff = new Date().getTime() - new Date(transaction.Date).getTime();
    const dateDiff = timeDiff / (1000 * 3600 * 24);
    if (dateDiff < 90 && this.sharedService.isBossAccount() == false && !this.sharedService.isFinance()) {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = "Confirm to delete transaction amount = RM " + transaction.Amount + " and remark=" + transaction.Remark + "?";

      modalRef.result.then((confirm) => {
        if (confirm) {
          const modalRef = this.sharedService.openModal(DeleteReasonRemarkComponent);
          modalRef.componentInstance.transaction = transaction;
          modalRef.componentInstance.passEntry.subscribe((entry) => {
            const remark = entry;

            //append added account to account list
            this.deleteTransaction(remark, transaction.ID, transaction.Type);
          });
        }
      });
    }
    else
      this.sharedService.openAlert("This transaction is too old, please contact your admin to delete", ALERT_TYPE.DANGER);
  }

  deleteTransaction(remark: string, transactionID: number, transactionType: number) {
    const data =
    {
      "reason": remark
    };

    let xhr;
    switch (transactionType) {
      case this.enums.RESERVE:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteReserveTransaction(transactionID), data);
        break;
      case this.enums.BAD_DEBT:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteBadDebtTransaction(transactionID), data);
        break;
      case this.enums.PRINCIPAL:
      case this.enums.MONTHLY_INTEREST:
      case this.enums.REPAYMENT:
      case this.enums.PROCESSING_CHARGE:
      case this.enums.ARREAR_CHARGES:
      case this.enums.EXTRA_INTEREST:
      case this.enums.BOUNTY:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteLoanTransaction(transactionID), data);
        break;

      case this.enums.ADVANCE:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteAdvanceTransaction(transactionID), data);
        break;
      case this.enums.ASSET:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteAssetTransaction(transactionID), data);
        break;
      default:
        xhr = this.restApi.deleteRequest(this.constructApi.getDeleteTransaction(transactionID), data);
        break;
    }

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.removeTransctionFromList(transactionID);
          this.isDirty = true;
        }
        else {
          // this.sharedService.openAlert("Opps, some errors occured. Please try again later");
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  removeTransctionFromList(transactionId: number) {
    for (let i = 0; i < this.transactionList.length; i++) {
      if (Number(this.transactionList[i].ID) == transactionId) {
        this.transactionList.splice(i, 1);
        this.cdr.detectChanges();

        if (this.transactionList.length == 0)
          window.location.reload();
      }
    }
    return -1
  }

  getAccountCarryForwardAmount() {
    this.carryForwardAmount = 0;
    if (this.startDate != undefined)
      //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
      // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
      var reduceASecDate = new Date(Number(this.startDate) - 1);
    const endDateStr = reduceASecDate.toISOString();

    const xhttp = this.restApi.getRequest(this.constructApi.getAccount(this.accountId, endDateStr));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const json = JSON.parse((xhttp.responseText));
        this.carryForwardAmount = json.balance;
      }
    };
  }

  getAllTransactions() {
    this.getAccountCarryForwardAmount();
    this.transactionList.splice(0, this.transactionList.length);
    const startDateStr = (this.startDate == undefined) ? undefined : this.startDate.toISOString();

    if (this.endDate != undefined)
      //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
      // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
      var addADayDate = new Date(Number(this.endDate) + (3600 * 1000 * 24) - 1);

    const endDateStr = (this.endDate == undefined) ? undefined : addADayDate.toISOString();
    const types = [this.enums.STAMP, this.enums.SERVICE_CHARGE, this.enums.EXTRAS, this.enums.ASSET, this.enums.BAD_DEBT, this.enums.RESERVE, this.enums.ADVANCE, this.enums.TRANSFER, this.enums.REALLOCATION, this.enums.INCOME, this.enums.EXPENSE,
    this.enums.CAPITAL, this.enums.SAVING, this.enums.TOTING]

    const xhttp = this.restApi.getRequest(this.constructApi.getAllTransactions(this.selectedCompany, types, startDateStr, endDateStr, undefined, undefined, this.accountId, this.selectedUsername));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {
          const transaction = new Transaction(json.id, json.remark, json.amount, json.closingBalance, json.accountId, json.date, json.type, json.handleBy, undefined, undefined, undefined, undefined, undefined, json.subtype);

          if (json.type == this.enums.EXTRAS || json.type == this.enums.STAMP || json.type == this.enums.SERVICE_CHARGE) {
            if (json.loanId == undefined) {
              this.transactionList.push(transaction);
            }
          }
          else
            this.transactionList.push(transaction);
          this.transactionList.sort((a, b) => (a.ID > b.ID) ? 1 : -1);
        });

        this.getAllAccountLoanTransaction();
      }
    };
  }

  getAllAccountLoanTransaction() {
    const startDateStr = (this.startDate == undefined) ? undefined : this.startDate.toISOString();

    if (this.endDate != undefined)
      //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
      // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
      var addADayDate = new Date(Number(this.endDate) + (3600 * 1000 * 24) - 1);
    const endDateStr = (this.endDate == undefined) ? undefined : addADayDate.toISOString();

    const xhttp = this.restApi.getRequest(this.constructApi.getCompanyAllLoansTransactions(this.selectedCompany, startDateStr, endDateStr, undefined, undefined, this.accountId, this.selectedUsername));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {
          const transaction = new Transaction(json.id, json.remark, json.amount, json.closingBalance, json.accountId, json.date, json.type, json.handleBy, json.receiptId, json.customerId, json.customerName, json.icNumber, json.occupation, json.subtype);

          this.transactionList.push(transaction);

          this.transactionList.sort((a, b) => (a.ID > b.ID) ? 1 : -1);
        });
      }
    };
  }

  private async getAllUsersInCompany() {
    this.userList = await this.userService.getAllUsers();
  }

  goToCustomer(customerID: number) {
    this.activeModal.close();
    this.router.navigate(['/manageCustomer', customerID]);
  }

  closeModal() {
    if (this.isDirty == true)
      window.location.reload();
    else
      this.activeModal.close();
  }

  calculateTotalTransaction(transaction: Transaction[]) {
    let sum: number = this.carryForwardAmount;
    for (let i = 0; i < transaction.length; i++) {
      sum += transaction[i].Amount;
    }
    return sum;
  }

  calculateTotalIn(transaction: Transaction[]) {
    let sum = 0;
    for (let i = 0; i < transaction.length; i++) {
      if (transaction[i].Amount >= 0)
        sum += transaction[i].Amount;
    }
    return sum;
  }

  calculateTotalOut(transaction: Transaction[]) {
    let sum = 0;
    for (let i = 0; i < transaction.length; i++) {
      if (transaction[i].Amount < 0)
        sum += transaction[i].Amount;
    }
    return sum;
  }

  checkAmountInOut(amount: number) {
    if (amount < 0)
      return 'negative';
    else
      return 'positive';
  }

  getTransactionColor(transactionAmount: number) {
    if (transactionAmount >= 0)
      return 'positive';
    else
      return 'negative';
  }
}
